webpackJsonp([0],{

/***/ "+8o3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var $, site;

site = __webpack_require__("PaZl");

$ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-nav',
  data: function() {
    return {
      socialLinks: site.social.links,
      open: false,
      darkLogo: __webpack_require__("c119")
    };
  },
  methods: {
    toggle: function() {
      return this.open = !this.open;
    },
    goto: function(selector, e) {
      var offset;
      e.preventDefault();
      offset = 0;
      if (selector === '#contact') {
        offset = 2000;
      }
      $('html, body').animate({
        scrollTop: $(selector).offset().top + offset,
        easing: 'swing'
      }, 1000);
      if (this.open) {
        return this.toggle();
      }
    }
  }
});


/***/ }),

/***/ "/Ezm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-game-header",class:_vm.classes},[_c('lucre-full-height-block',[(_vm.type)?_c('p',{staticClass:"type"},[_vm._v(_vm._s(_vm.type))]):_vm._e(),_c('h2',[(_vm.logo)?_c('visual',{staticClass:"logo",attrs:{"image":_vm.logo,"alt":_vm.game}}):_vm._e()],1),(_vm.copy)?_c('h3',{staticClass:"copy"},[_vm._v(_vm._s(_vm.copy))]):_vm._e()]),_c('visual',{staticClass:"background",attrs:{"image":_vm.background,"background":"cover"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Ent":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haos-game-lucre-games-gameplay-3.6165ef9.gif";

/***/ }),

/***/ "0H2d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-footer'
});


/***/ }),

/***/ "0Z+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-spinning-cube"},[_c('div',{staticClass:"cube-container"},[_c('div',{staticClass:"cube animate"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0dQi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1KXc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-newsletter-signup"},[_c('p',{staticClass:"faded"},[_vm._v("Get updated on latest the from Lucre Games.")]),_c('div',{attrs:{"id":"mc_embed_signup"}},[_c('form',{staticClass:"validate",attrs:{"id":"mc-embedded-subscribe-form","action":"//thelucre.us13.list-manage.com/subscribe/post?u=e9adb6c85e6b48778369f812a&id=e9adde9ef1","method":"post","name":"mc-embedded-subscribe-form","target":"_blank","novalidate":"","data-gtm":"Newsletter Signup","data-gtm-value":"Submit"}},[_c('div',{attrs:{"id":"mc_embed_signup_scroll"}},[_c('div',{staticClass:"mc-field-group"},[_c('input',{staticClass:"required email",attrs:{"id":"mce-EMAIL","type":"email","value":"","name":"EMAIL","placeholder":"Enter your email"}}),_c('input',{staticClass:"button",attrs:{"id":"mc-embedded-subscribe","type":"submit","value":"Subscribe","name":"subscribe","data-gtm":"Footer > Newsletter","data-gtm-value":"Submit"}})])]),_c('div',{staticClass:"clear",attrs:{"id":"mce-responses"}},[_c('div',{staticClass:"response",staticStyle:{"display":"none"},attrs:{"id":"mce-error-response"}}),_c('div',{staticClass:"response",staticStyle:{"display":"none"},attrs:{"id":"mce-success-response"}})]),_c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_e9adb6c85e6b48778369f812a_e9adde9ef1","tabindex":"-1","value":""}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "24R8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2hPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidewaysLabel_vue__ = __webpack_require__("hOA5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2768dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SidewaysLabel_vue__ = __webpack_require__("YBmO");
function injectStyle (ssrContext) {
  __webpack_require__("SzdS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidewaysLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2768dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SidewaysLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Ar6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3nEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-image-grid"},[_c('div',{staticClass:"content-max-w"},[(_vm.label)?_c('lucre-sideways-label',{attrs:{"label":_vm.label}}):_vm._e(),_vm._l((_vm.items),function(item){return (_vm.items)?_c('div',{staticClass:"grid-item",class:["cols-"+_vm.columns]},[(item.link)?_c('a',{attrs:{"href":item.link,"data-gtm":'Image Grid > '+_vm.label,"data-gtm-value":item.title},on:{"click":function($event){_vm.goto(item.link, $event)}}}):_vm._e(),(item.image)?_c('visual',{attrs:{"image":item.image}}):_vm._e()],1):_vm._e()})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3vt/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haos-lucre-games-thumbnail.e5cb4c2.jpg";

/***/ }),

/***/ "45bU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var $;

$ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'image-grid',
  props: {
    label: {
      type: String,
      default: null
    },
    // Images per column. Supports 2 and 3
    columns: {
      type: Number,
      default: 2
    },
    // Grid items. Should have these keys:
    //   image - loaded asset file 
    //   link - supports absolute, relative, and anchor links
    items: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    goto: function(selector, e) {
      if (selector.indexOf('#') === 0) {
        return $('html, body').animate({
          scrollTop: $(selector).offset().top,
          easing: 'swing'
        }, 1000);
      } else {
        return true;
      }
    }
  }
});


/***/ }),

/***/ "4IjM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-trailer-screen.751ab28.jpg";

/***/ }),

/***/ "4p/4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5WVf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "78XW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8mk0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'geotap-logo',
  data: function() {
    return {
      logo: __webpack_require__("0dQi")
    };
  }
});


/***/ }),

/***/ "9ZZC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGrid_vue__ = __webpack_require__("45bU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25eb24da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGrid_vue__ = __webpack_require__("3nEJ");
function injectStyle (ssrContext) {
  __webpack_require__("ZkZe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageGrid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25eb24da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ImageGrid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9oBU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AXdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsletterSignup_vue__ = __webpack_require__("WM2z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca17aab0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewsletterSignup_vue__ = __webpack_require__("1KXc");
function injectStyle (ssrContext) {
  __webpack_require__("4p/4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsletterSignup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca17aab0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NewsletterSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BZjC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C+62":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-google-play-icon.994e887.png";

/***/ }),

/***/ "C2r1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-geotap-game-casual-relaxing-low=poly-design-game-cards.315cc89.png";

/***/ }),

/***/ "D0cI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-mobile-unlockable-low-poly-shapes.b4e69eb.jpg";

/***/ }),

/***/ "EFXr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lost-ethereal-pixel-art-low-res-retro-8bit-bridges.6fa8fcb.gif";

/***/ }),

/***/ "EuUI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-store-links"},[_c('h3',[_vm._v("Play for free on Android and iOS")]),_c('a',{attrs:{"href":_vm.playStore.url,"target":"_blank","data-gtm":"GeoTap > Store Links > Click","data-gtm-value":"Play Store"}},[_c('img',{attrs:{"src":_vm.playStore.image}})]),_c('a',{attrs:{"href":_vm.appStore.url,"target":"_blank","data-gtm":"GeoTap > Store Links > Click","data-gtm-value":"App Store"}},[_c('img',{attrs:{"src":_vm.appStore.image}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ftyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLinks_vue__ = __webpack_require__("mK+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665580e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLinks_vue__ = __webpack_require__("EuUI");
function injectStyle (ssrContext) {
  __webpack_require__("TRlF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_665580e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G9kQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fly-by-fire-lucre-games-lowpoly-skeleton-tiki-tony.8c8fef6.jpg";

/***/ }),

/***/ "GSio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-social-links"},[_c('ul',_vm._l((_vm.links),function(link){return _c('li',[_c('a',{class:'icon-'+link.icon,attrs:{"href":link.url,"target":"_blank","data-gtm":"Social Links > Click","data-gtm-value":link.icon}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HNNl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-three-screens",class:_vm.classes,style:(_vm.styles)},[_c('div',{staticClass:"content-max-w"},[_c('lucre-sideways-label',{attrs:{"label":_vm.label,"color":_vm.labelColor}}),_c('visual',{staticClass:"screen screen1",attrs:{"image":_vm.screen1,"background":"cover"}}),_c('visual',{staticClass:"screen screen2",attrs:{"image":_vm.screen2,"background":"cover"}}),_c('visual',{staticClass:"screen screen3",attrs:{"image":_vm.screen3,"background":"cover"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HXef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Zhfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3481be94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("aasZ");
function injectStyle (ssrContext) {
  __webpack_require__("3Ar6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3481be94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3481be94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HjLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeotapLogo_vue__ = __webpack_require__("8mk0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71de4e8b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GeotapLogo_vue__ = __webpack_require__("z7ii");
function injectStyle (ssrContext) {
  __webpack_require__("BZjC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeotapLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71de4e8b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GeotapLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HvZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'game-header',
  props: ['color', 'game', 'type', 'logo', 'background', 'copy'],
  data: function() {
    return {
      styles: {
        'background-image': 'url("' + this.background + '")'
      },
      classes: 'theme-' + this.color
    };
  }
});


/***/ }),

/***/ "Hyvg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-classic-mode-mobile.d44e38f.jpg";

/***/ }),

/***/ "JnEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'lucre-logo',

  data: function data() {
    return { logo: __webpack_require__("ffyJ") };
  }
});

/***/ }),

/***/ "Kme/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameHeader_vue__ = __webpack_require__("HvZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9602afa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameHeader_vue__ = __webpack_require__("/Ezm");
function injectStyle (ssrContext) {
  __webpack_require__("Ozhc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9602afa6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "L6O3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LuWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-full-height"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("OWjy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("cX1j");
function injectStyle (ssrContext) {
  __webpack_require__("9oBU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_427a9fc7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_styl__ = __webpack_require__("tLzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__main_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_visual__ = __webpack_require__("c3y4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_visual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_visual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive__ = __webpack_require__("VYcz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive__);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('visual', __WEBPACK_IMPORTED_MODULE_4_vue_visual___default.a).options.setDefaults({
  load: 'visible',
  transition: 'fade',
  offset: 1500
});
__webpack_require__("5WVf");


__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('in-viewport', __WEBPACK_IMPORTED_MODULE_5_vue_in_viewport_directive___default.a);

__webpack_require__("Ulv0");

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NcAA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameLargeImage_vue__ = __webpack_require__("jdyW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ce3aa00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameLargeImage_vue__ = __webpack_require__("lgWU");
function injectStyle (ssrContext) {
  __webpack_require__("Q2Pi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameLargeImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ce3aa00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameLargeImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NpH0":
/***/ (function(module, exports, __webpack_require__) {

var description, ogDescr, ogImage, ogSiteName, ogTitle, ogTwitterDescr, ogTwitterImage, ogTwitterTitle, ogTwitterUrl, ogUrl, site, title;

site = __webpack_require__("PaZl");

title = document.querySelector("title");

ogImage = document.querySelector("meta[property='og:image']");

ogTwitterImage = document.querySelector("meta[property='twitter:image']");

ogTitle = document.querySelector("meta[property='og:title']");

ogTwitterTitle = document.querySelector("meta[property='twitter:title']");

ogUrl = document.querySelector("meta[property='og:url']");

ogTwitterUrl = document.querySelector("meta[property='twitter:url']");

description = document.querySelector("meta[name='description']");

ogDescr = document.querySelector("meta[property='og:description']");

ogTwitterDescr = document.querySelector("meta[property='twitter:description']");

ogSiteName = document.querySelector("meta[property='og:site_name']");

module.exports = {
  beforeMount: function() {
    if (!this.meta) {
      return;
    }
    if (this.meta.title) {
      title.text = this.meta.title;
    }
    if (this.meta.title) {
      ogTitle.content = this.meta.title;
    }
    if (this.meta.title) {
      ogTwitterTitle.content = this.meta.title;
    }
    if (this.meta.image) {
      ogImage.content = this.meta.image;
    }
    if (this.meta.image) {
      ogTwitterImage.content = this.meta.image;
    }
    if (this.meta.description) {
      description.content = this.meta.description;
    }
    if (this.meta.description) {
      ogDescr.content = this.meta.description;
    }
    if (this.meta.description) {
      ogTwitterDescr.content = this.meta.description;
    }
    ogUrl.content = site.page.url + this.meta.route;
    ogTwitterUrl.content = site.page.url + this.meta.route;
    if (this.meta.title) {
      return ogSiteName.content = this.meta.title;
    }
  }
};


/***/ }),

/***/ "NtDV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fly-by-fire-lucre-games-lowpoly-gas-can-bullets.d8f9e26.jpg";

/***/ }),

/***/ "OWjy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});


/***/ }),

/***/ "Od4l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OiBX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_geotap_SpinningCube__ = __webpack_require__("feoz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_geotap_StoreLinks__ = __webpack_require__("Ftyh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_geotap_GeotapLogo__ = __webpack_require__("HjLE");
var $;

$ = __webpack_require__("7t+N");







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marquee',
  data: function() {
    return {
      ready: false,
      geotapCards: __webpack_require__("C2r1"),
      indiePrize: __webpack_require__("m1Vw")
    };
  },
  components: {
    'spinning-cube': __WEBPACK_IMPORTED_MODULE_0__components_geotap_SpinningCube__["a" /* default */],
    'store-links': __WEBPACK_IMPORTED_MODULE_1__components_geotap_StoreLinks__["a" /* default */],
    'geotap-logo': __WEBPACK_IMPORTED_MODULE_2__components_geotap_GeotapLogo__["a" /* default */]
  },
  beforeMount: function() {
    return setTimeout(this.buildin, 200);
  },
  methods: {
    // Scroll down to the next main section
    onDownArrowClick: function() {
      return $('html, body').animate({
        scrollTop: $(".lucre-game-cards").offset().top - 50,
        easing: 'swing'
      }, 1000);
    }
  }
});


/***/ }),

/***/ "Ozhc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PaZl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {
  // Replace the image at this path with a 512x512 png
  favicon: "../src/assets/favicon.png",

  page: {
    title: "Lucre Games 🤞 An Indie Game Studio",
    description: "Creating game experiences that balance fun with intrigue and mechanics with art.",
    keywords: "Lucre, Games, Lucre Games, Indie Game Studio, Game Developers, Mobile Game Developers, Indie Game Developers",
    url: "https://lucregames.com",
  },

  social: {
    image: "https://lucregames.com/static/lucre-games-indie-game-sacramento-social-card.jpg",
    links: [
      { icon: 'itch', url: 'https://lucregames.itch.io' },
      { icon: 'twitter', url: 'https://twitter.com/LucreGames/' },
      { icon: 'facebook', url: 'https://www.facebook.com/LucreGames/' },
    ]
  },

  gtmContainer: 'GTM-PDC47N5',

}


/***/ }),

/***/ "Q2Pi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q9Xi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-floating-image",style:(_vm.styles)},[_c('visual',{attrs:{"image":_vm.image}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qtjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var $;

$ = __webpack_require__("7t+N");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'game-trailer',
  props: ['label', 'aspect', 'youtubeId', 'maxWidth', 'image'],
  data: function() {
    return {
      clicked: false
    };
  },
  computed: {
    styles: function() {
      return {
        paddingBottom: (this.aspect[1] / this.aspect[0] * 100) + '%'
      };
    },
    videoSource: function() {
      var src;
      src = 'https://www.youtube.com/embed/' + this.youtubeId + '?rel=0&amp;showinfo=0';
      if (this.clicked) {
        src += '&autoplay=1';
      }
      return src;
    }
  },
  methods: {
    onClick: function(e) {
      $(this.$refs.cover).remove();
      return this.clicked = true;
    }
  }
});


/***/ }),

/***/ "R2Yh":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haos-game-lucre-games-gameplay-2.156df38.gif";

/***/ }),

/***/ "Suea":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SzdS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TRlF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UcK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'three-screens',
  props: ['layout', 'bgcolor', 'label', 'screen1', 'screen2', 'screen3', 'labelColor'],
  data: function() {
    return {
      styles: {
        backgroundColor: this.bgcolor
      },
      classes: 'layout-' + this.layout
    };
  }
});


/***/ }),

/***/ "Ul09":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fly-by-fire-lucre-games-lowpoly-landscape-poster.924422b.jpg";

/***/ }),

/***/ "Ulv0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_global_LucreLogo__ = __webpack_require__("v4Gn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_global_MainNav__ = __webpack_require__("W3Sx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_global_SocialLinks__ = __webpack_require__("pvL/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_generic_FullHeightBlock__ = __webpack_require__("rWvo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_generic_SidewaysLabel__ = __webpack_require__("2hPw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_global_MainFooter__ = __webpack_require__("m4Ty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_generic_NewsletterSignup__ = __webpack_require__("AXdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_generic_NavToggle__ = __webpack_require__("loMK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_generic_FloatingImage__ = __webpack_require__("mxc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_generic_ImageGrid__ = __webpack_require__("9ZZC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_game_GameHeader__ = __webpack_require__("Kme/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_game_ThreeScreens__ = __webpack_require__("Vntk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_game_GameTrailer__ = __webpack_require__("WqoN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_game_GameLargeImage__ = __webpack_require__("NcAA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_geotap_Marquee__ = __webpack_require__("vAsX");
/**
 * Register global Vue components
 */




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-logo', __WEBPACK_IMPORTED_MODULE_1__components_global_LucreLogo__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-main-nav', __WEBPACK_IMPORTED_MODULE_2__components_global_MainNav__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-social-links', __WEBPACK_IMPORTED_MODULE_3__components_global_SocialLinks__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-full-height-block', __WEBPACK_IMPORTED_MODULE_4__components_generic_FullHeightBlock__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-sideways-label', __WEBPACK_IMPORTED_MODULE_5__components_generic_SidewaysLabel__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-main-footer', __WEBPACK_IMPORTED_MODULE_6__components_global_MainFooter__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-newsletter-signup', __WEBPACK_IMPORTED_MODULE_7__components_generic_NewsletterSignup__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-nav-toggle', __WEBPACK_IMPORTED_MODULE_8__components_generic_NavToggle__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-floating-image', __WEBPACK_IMPORTED_MODULE_9__components_generic_FloatingImage__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-image-grid', __WEBPACK_IMPORTED_MODULE_10__components_generic_ImageGrid__["a" /* default */]);

/**
 GAME SECTIONS
 */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-game-header', __WEBPACK_IMPORTED_MODULE_11__components_game_GameHeader__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-three-screens', __WEBPACK_IMPORTED_MODULE_12__components_game_ThreeScreens__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-game-trailer', __WEBPACK_IMPORTED_MODULE_13__components_game_GameTrailer__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('lucre-game-large-image', __WEBPACK_IMPORTED_MODULE_14__components_game_GameLargeImage__["a" /* default */]);

/**
 * GEOTAP
 */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('geotap-marquee', __WEBPACK_IMPORTED_MODULE_15__components_geotap_Marquee__["a" /* default */]);

/***/ }),

/***/ "UxYP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-logo"},[_c('visual',{attrs:{"image":_vm.logo,"load":"visible","offset":"200","alt":"Lucre Games Logo - Indie Game Studio in Sacramento"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vntk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreeScreens_vue__ = __webpack_require__("UcK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296d1ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ThreeScreens_vue__ = __webpack_require__("HNNl");
function injectStyle (ssrContext) {
  __webpack_require__("hLzJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThreeScreens_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296d1ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ThreeScreens_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VoS7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-cone-lowpoly-shape.6db16fd.jpg";

/***/ }),

/***/ "W3Sx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNav_vue__ = __webpack_require__("+8o3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11985306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MainNav_vue__ = __webpack_require__("Z2zz");
function injectStyle (ssrContext) {
  __webpack_require__("t75W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11985306_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MainNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WM2z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newsletter-signup'
});


/***/ }),

/***/ "WPxt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fly-by-fire-lucre-games-thumbnail.9b743e4.jpg";

/***/ }),

/***/ "WqoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameTrailer_vue__ = __webpack_require__("Qtjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_972cf47a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameTrailer_vue__ = __webpack_require__("k2HZ");
function injectStyle (ssrContext) {
  __webpack_require__("Od4l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GameTrailer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_972cf47a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GameTrailer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XPB6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-coin-low-poly-3d-rotating.9000997.gif";

/***/ }),

/***/ "YBmO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-sideways-label"},[_c('div',{staticClass:"container"},[_c('p',{style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes__ = __webpack_require__("abeU");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_2__router_routes__["a" /* default */],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ "Z2zz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"lucre-main-nav",class:{ open : _vm.open }},[_c('div',{staticClass:"cover-all",on:{"click":_vm.toggle}}),_c('div',{staticClass:"nav-area"},[_c('lucre-nav-toggle',{attrs:{"click":_vm.toggle,"is-open":_vm.open}}),_c('visual',{staticClass:"logo",attrs:{"image":_vm.darkLogo}}),_c('div',{staticClass:"top-links"},[_c('a',{attrs:{"href":"#","data-gtm":"Main Nav > Click","data-gtm-value":"Mission"},on:{"click":function($event){_vm.goto("#mission", $event)}}},[_vm._v("Mission")]),_c('a',{attrs:{"href":"#","data-gtm":"Main Nav > Click","data-gtm-value":"Games"},on:{"click":function($event){_vm.goto("#games", $event)}}},[_vm._v("Games")]),_c('a',{attrs:{"href":"#","data-gtm":"Main Nav > Click","data-gtm-value":"Contact"},on:{"click":function($event){_vm.goto("#contact", $event)}}},[_vm._v("Contact")])]),_c('lucre-social-links',{attrs:{"links":_vm.socialLinks}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Zhfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var metaMixin;

metaMixin = __webpack_require__("NpH0");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home-page',
  mixins: [metaMixin],
  // components:
  data: function() {
    return {
      activeGradient: 0,
      meta: {
        title: 'Lucre Games 🤞 An Indie Game Studio',
        description: 'Creating game experiences that balance fun with intrigue and mechanics with art.',
        image: 'https://lucregames.com/static/lucre-games-indie-game-sacramento-social-card.jpg',
        route: '/'
      },
      images: {
        fbfLogo: __webpack_require__("mFqI"),
        fbfTony: __webpack_require__("G9kQ"),
        fbfPoster: __webpack_require__("Ul09"),
        fbfGascan: __webpack_require__("NtDV"),
        haosLogo: __webpack_require__("atPT"),
        haosBanner: __webpack_require__("guZ8"),
        haosGameplay1: __webpack_require__("qWhF"),
        haosGameplay2: __webpack_require__("R2Yh"),
        haosGameplay3: __webpack_require__("0Ent"),
        leBanner: __webpack_require__("xIC3"),
        leLogo: __webpack_require__("o3xb"),
        leBridge: __webpack_require__("EFXr"),
        leWindmill: __webpack_require__("tFs0"),
        leDesert: __webpack_require__("qDqw"),
        geotapScreen1: __webpack_require__("Hyvg"),
        geotapScreen2: __webpack_require__("k5zq"),
        geotapScreen3: __webpack_require__("kVHJ"),
        coin: __webpack_require__("XPB6"),
        geotapTrailer: __webpack_require__("4IjM"),
        geotapShapes: __webpack_require__("D0cI"),
        stairs: __webpack_require__("wtl0"),
        chapel: __webpack_require__("q6A1"),
        cone: __webpack_require__("VoS7")
      },
      gameGrid: [
        {
          title: 'GeoTap',
          link: '#geotap',
          image: __webpack_require__("bLv7")
        },
        {
          title: 'HAOS',
          link: '#haos',
          image: __webpack_require__("3vt/")
        },
        {
          title: 'Fly by Fire',
          link: '#fly-by-fire',
          image: __webpack_require__("WPxt")
        },
        {
          title: 'Lost Ethereal',
          link: '#lost-ethereal',
          image: __webpack_require__("f1kN")
        }
      ]
    };
  }
});


/***/ }),

/***/ "ZkZe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aasZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page home-page"},[_c('lucre-floating-image',{attrs:{"image":_vm.images.stairs,"x":"70","y":"60","width":"50","opacity":"0.15"}}),_c('lucre-floating-image',{attrs:{"image":_vm.images.cone,"x":"0","y":"40","width":"17","opacity":"0.15"}}),_c('lucre-floating-image',{attrs:{"image":_vm.images.chapel,"x":"55","y":"-10","width":"10","opacity":"0.15"}}),_c('lucre-full-height-block',[_c('h1',[_c('lucre-logo')],1)]),_c('lucre-full-height-block',[_c('div',{staticClass:"lucre-definition"},[_c('h2',{staticClass:"word"},[_vm._v("lu·cre")]),_c('p',{staticClass:"phonetics"},[_vm._v("lu·cre  \\ ˈlü-kər \\")]),_c('p',{staticClass:"explanation faded"},[_vm._v("Money, especially when regarded as sordid or distasteful or gained in a dishonorable way.")])])]),_c('lucre-full-height-block',[_c('visual',{staticClass:"gold-coin",attrs:{"image":_vm.images.coin}}),_c('h2',{staticClass:"seriously gold"},[_vm._v("seriously though...")])],1),_c('lucre-full-height-block',{attrs:{"id":"mission"}},[_c('div',{staticClass:"mission"},[_c('h2',[_vm._v("We are creating game experiences that balance fun with intrigue and mechanics with art.")]),_c('p',{staticClass:"faded"},[_vm._v("…while tastefully making games in a reputable and honorable way")]),_c('p',{staticClass:"emoji"},[_vm._v("🤞")])])]),_c('lucre-image-grid',{attrs:{"id":"games","label":"Our Games","items":_vm.gameGrid}}),_c('geotap-marquee',{attrs:{"id":"geotap"}}),_c('lucre-game-trailer',{attrs:{"label":"Play Trailer","aspect":[9,16],"max-width":"350px","youtube-id":"1o2nTO3U2vU","image":_vm.images.geotapTrailer}}),_c('lucre-three-screens',{attrs:{"layout":"tall","label":"Game Modes","screen1":_vm.images.geotapScreen1,"screen2":_vm.images.geotapScreen2,"screen3":_vm.images.geotapScreen3}}),_c('div',{staticClass:"section"},[_c('div',{staticClass:"content-max-w"},[_c('div',{staticClass:"unlockables"},[_c('visual',{attrs:{"image":_vm.images.coin}}),_c('lucre-sideways-label',{attrs:{"label":"Unlockables"}})],1)])]),_c('lucre-game-large-image',{attrs:{"image":_vm.images.geotapShapes}}),_c('lucre-game-header',{attrs:{"id":"haos","type":"Coming Soon","game":"HÄŌS","logo":_vm.images.haosLogo,"copy":"A cyber-cellular cosmic petri-dish sound-wave blasting action art game.","color":"black","background":_vm.images.haosBanner}}),_c('lucre-three-screens',{attrs:{"layout":"square","label-color":"black","screen1":_vm.images.haosGameplay1,"screen2":_vm.images.haosGameplay2,"screen3":_vm.images.haosGameplay3,"label":"The Action","bgcolor":"#D0D0D0"}}),_c('lucre-game-header',{attrs:{"id":"fly-by-fire","type":"Coming Soon","game":"Fly By Fire","logo":_vm.images.fbfLogo,"copy":"A gentleperson's battle royale of aerial carnage","background":"http://yo.bkwld.com/070B060G2W1y/Image%202018-01-11%20at%2012.53.43%20PM.png"}}),_c('lucre-three-screens',{attrs:{"layout":"tall","label":"Artwork","screen1":_vm.images.fbfPoster,"screen2":_vm.images.fbfGascan,"screen3":_vm.images.fbfTony}}),_c('lucre-game-header',{attrs:{"id":"lost-ethereal","type":"Coming Soon","game":"Lost Ethereal","logo":_vm.images.leLogo,"copy":"A pressureless and puzzling romp through the spirit world","background":_vm.images.leBanner}}),_c('lucre-three-screens',{attrs:{"layout":"square","screen1":_vm.images.leBridge,"screen2":_vm.images.leWindmill,"screen3":_vm.images.leDesert,"label":"The World"}}),_c('lucre-main-footer',{attrs:{"id":"contact"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "abeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Home__ = __webpack_require__("HXef");
var routes;



routes = [
  {
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_0__pages_Home__["a" /* default */]
  },
  {
    // 404 Catch all
    path: '*',
    redirect: '/'
  }
];

/* harmony default export */ __webpack_exports__["a"] = (routes);


/***/ }),

/***/ "atPT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haos-game-lucre-games-logo-black.b87aa20.png";

/***/ }),

/***/ "bGvG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bLv7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-lucre-games-thumbnail.9b86c6c.jpg";

/***/ }),

/***/ "bT+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c119":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-indie-game-sacramento-logo-black.b25a834.png";

/***/ }),

/***/ "cX1j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('lucre-main-nav'),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f1kN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lost-ethereal-lucre-games-thumbnail.de69316.jpg";

/***/ }),

/***/ "feoz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningCube_vue__ = __webpack_require__("tRhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4d8bd9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningCube_vue__ = __webpack_require__("0Z+c");
function injectStyle (ssrContext) {
  __webpack_require__("24R8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinningCube_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4d8bd9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SpinningCube_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ffyJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-indie-game-sacramento-logo-white.5825310.png";

/***/ }),

/***/ "gt2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full-height'
});


/***/ }),

/***/ "guZ8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haos-game-lucre-games-banner.2f660dd.jpg";

/***/ }),

/***/ "hLzJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hOA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sideways-label',
  props: {
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'white'
    }
  }
});


/***/ }),

/***/ "iTZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'social-links',

  props: ['links']
});

/***/ }),

/***/ "jdyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'game-large-image',
  props: ['image']
});


/***/ }),

/***/ "k2HZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-game-trailer"},[_c('div',{staticClass:"content-max-w"},[_c('div',{staticClass:"video-limiter",style:({ "max-width": _vm.maxWidth }),attrs:{"data-gtm":"GeoTap > Trailer","data-gtm-value":"Play"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"video-container",style:(_vm.styles)},[_c('lucre-sideways-label',{attrs:{"label":_vm.label}}),_c('visual',{ref:"cover",staticClass:"cover-image",class:{ hide: _vm.clicked },attrs:{"background":"cover","image":_vm.image}}),_c('iframe',{ref:"video",attrs:{"src":_vm.videoSource,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":"allowfullscreen"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k5zq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-tranquil-mode-mobile.873f4eb.jpg";

/***/ }),

/***/ "kVC6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-main-footer"},[_c('div',{staticClass:"content-max-w"},[_c('h1',[_vm._v("Continue?")]),_c('p',{staticClass:"intro faded"},[_vm._v("The fate of the world depends on you contacting us")]),_c('div',{staticClass:"emoji"},[_vm._v("🖖")]),_vm._m(0),_c('lucre-newsletter-signup')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pillars"},[_c('div',{staticClass:"pillar"},[_c('h3',[_vm._v("Hey fan girls and boys,")]),_c('p',[_vm._v("wanna discuss games, have a")]),_c('p',[_vm._v("brew, or talk shop? So do we!")]),_c('a',{staticClass:"gold",attrs:{"href":"mailto:hello@lucregames.com","data-gtm":"Footer > Contact > Click","data-gtm-value":"hello@lucregames.com"}},[_vm._v("hello@lucregames.com")])]),_c('div',{staticClass:"pillar"},[_c('h3',[_vm._v("Hey publishers,")]),_c('p',[_vm._v("does something you see")]),_c('p',[_vm._v("excite you? Let us know!")]),_c('a',{staticClass:"gold",attrs:{"href":"mailto:publish@lucregames.com","data-gtm":"Footer > Contact > Click","data-gtm-value":"publish@lucregames.com"}},[_vm._v("publish@lucregames.com")])]),_c('div',{staticClass:"pillar"},[_c('h3',[_vm._v("Hey business partners,")]),_c('p',[_vm._v("need a game created or")]),_c('p',[_vm._v("want to team up? 👇👇👇")]),_c('a',{staticClass:"gold",attrs:{"href":"mailto:business@lucregames.com","data-gtm":"Footer > Contact > Click","data-gtm-value":"business@lucregames.com"}},[_vm._v("business@lucregames.com")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kVHJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-lucre-games-focus-mode-mobile.457f09f.jpg";

/***/ }),

/***/ "knKY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lucre-games-app-store-icon.9bc2018.png";

/***/ }),

/***/ "lgWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-game-large-image"},[_c('div',{staticClass:"content-max-w"},[_c('visual',{attrs:{"image":_vm.image}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "loMK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavToggle_vue__ = __webpack_require__("wfv4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d8fd0f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NavToggle_vue__ = __webpack_require__("wKJq");
function injectStyle (ssrContext) {
  __webpack_require__("sbhn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavToggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d8fd0f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NavToggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m1Vw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/indie-prize-casual-connect-lucre-games-2018.9150e2b.png";

/***/ }),

/***/ "m4Ty":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__ = __webpack_require__("0H2d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3567df31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__ = __webpack_require__("kVC6");
function injectStyle (ssrContext) {
  __webpack_require__("L6O3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3567df31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mFqI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fly-by-fire-logo-lucre-games.1173cfe.png";

/***/ }),

/***/ "mK+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'store-links',
  props: ['appStoreUrl', 'playStoreUrl'],
  data: function() {
    return {
      playStore: {
        image: __webpack_require__("C+62"),
        url: this.playStoreUrl
      },
      appStore: {
        image: __webpack_require__("knKY"),
        url: this.appStoreUrl
      }
    };
  }
});


/***/ }),

/***/ "mxc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FloatingImage_vue__ = __webpack_require__("xRN6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c98c40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_FloatingImage_vue__ = __webpack_require__("Q9Xi");
function injectStyle (ssrContext) {
  __webpack_require__("r8hO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FloatingImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c98c40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_FloatingImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o3xb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lost-ethereal-lucre-games-indie-game-logo.af8b6e7.jpg";

/***/ }),

/***/ "pvL/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinks_vue__ = __webpack_require__("iTZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e5b5f9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinks_vue__ = __webpack_require__("GSio");
function injectStyle (ssrContext) {
  __webpack_require__("78XW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e5b5f9f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_SocialLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q6A1":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ "qDqw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lost-ethereal-pixel-art-low-res-retro-8bit-desert.71a34a4.png";

/***/ }),

/***/ "qWhF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/haos-game-lucre-games-gameplay-1.f62f18f.gif";

/***/ }),

/***/ "qruB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section lucre-marquee"},[_c('geotap-logo'),_vm._m(0),_c('spinning-cube'),_c('store-links',{attrs:{"app-store-url":"https://geotapgame.com/ios","play-store-url":"https://geotapgame.com/android"}}),_vm._m(1),_c('a',{attrs:{"href":"http://indieprize.org/usa2018/","target":"_blank","data-gtm":"GeoTap > Link > Click","data-gtm-value":"Indie Prize"}},[_c('visual',{staticClass:"prize",attrs:{"image":_vm.indiePrize}})],1),_c('visual',{staticClass:"cards",attrs:{"image":_vm.geotapCards}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_c('span',[_vm._v("A subtly addictive stress-relief game.")]),_c('br'),_c('span',[_vm._v("Unwind by focusing on something simple and beautiful.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"website-link"},[_c('span',[_vm._v("Learn more at ")]),_c('a',{attrs:{"href":"https://www.geotapgame.com","target":"_blank","data-gtm":"GeoTap > Link > Click","data-gtm-value":"geotapgame.com"}},[_vm._v("geotapgame.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r8hO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rWvo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullHeightBlock_vue__ = __webpack_require__("gt2n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b0a920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_FullHeightBlock_vue__ = __webpack_require__("LuWj");
function injectStyle (ssrContext) {
  __webpack_require__("bGvG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FullHeightBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78b0a920_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_FullHeightBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sbhn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t75W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tFs0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lost-ethereal-pixel-art-low-res-retro-8bit-windmill.8451d6d.gif";

/***/ }),

/***/ "tLzU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tRhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'spinning-cube',
  data: function() {
    return {
      ready: true
    };
  }
});


/***/ }),

/***/ "v4Gn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LucreLogo_vue__ = __webpack_require__("JnEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_983a21ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LucreLogo_vue__ = __webpack_require__("UxYP");
function injectStyle (ssrContext) {
  __webpack_require__("Suea")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LucreLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_983a21ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LucreLogo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vAsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marquee_vue__ = __webpack_require__("OiBX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510a9e84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Marquee_vue__ = __webpack_require__("qruB");
function injectStyle (ssrContext) {
  __webpack_require__("bT+p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__coffee_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marquee_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_510a9e84_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Marquee_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wKJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-nav-toggle",class:{ open : _vm.isOpen },on:{"click":_vm.click}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bars"},[_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"bar"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wfv4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nav-toggle',
  props: ['click', 'isOpen']
});


/***/ }),

/***/ "wtl0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/geotap-game-stairs-lowpoly-shape.ec37076.jpg";

/***/ }),

/***/ "xIC3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/lost-ethereal-lucre-games-pixel-art-banner.cd82284.jpg";

/***/ }),

/***/ "xRN6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'floating-image',
  props: ['image', 'x', 'y', 'width', 'opacity'],
  computed: {
    styles: function() {
      return {
        left: this.x + '%',
        top: this.y + '%',
        width: this.width + '%',
        opacity: this.opacity
      };
    }
  }
});


/***/ }),

/***/ "z7ii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-geotap-logo"},[_c('visual',{attrs:{"image":_vm.logo}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a961bd4bfc2f7b1b8f16.js